import { useEffect, useState } from 'react'
import './categories.scss';
import { useWordService, useWordCategoryService } from '../../../core/hooks/services/word.service';
import SearchGeneral from '../../../components/content/searchs/search_general/SearchGeneral';
import CardItemList from '../../../components/content/cards/card_item_list/CardItemList';

export default function Categories({ setPageTitle }: any) {

  // Nombre de la página
  const namePage = 'Categorías';

  useEffect(() => {

    // Titulos de pagina
    setPageTitle(namePage);
    document.title = `${namePage} | SeñaTech`;

  }, [setPageTitle]);


  // Llamada al servicio de palabras
  const { content, loading, error } = useWordService();
  const [dataWord, setDataWord] = useState({});

  const { content: contentWordCategory, loading: loadingWordCategory, error: errorWordCategory } = useWordCategoryService(5);
  const [dataWordCategory, setDataWordCategory] = useState<Record<string, any>>({});

  useEffect(() => {

    // Función para obtener los datos de las palabras
    const fetchData = async () => {
      const result = await content();
      if (result) {
        setDataWord(result.data.word)
      }
    };

    // Función para obtener los datos de las palabras de categorias
    const fetchWordCategoryData = async () => {
      const result = await contentWordCategory();
      if (result) {
        setDataWordCategory(result.data.wordByCategory)
      }
    };

    fetchData();
    fetchWordCategoryData();
  }, []);

  return (
    <section className='page content_categories'>
      <div className='title_content'>
        <h1 className='title'>Base de conocimiento</h1>
        <div className='search'>
          <SearchGeneral data={dataWord} showInitialResults={true} />
        </div>
      </div>

      <div className='info_content'>
        {dataWordCategory &&
          <CardItemList data={dataWordCategory} /> ||
          <div>
            No hay categorías para mostrar
          </div>
        }
      </div>
    </section>
  )
}
